import { cn } from "@/lib/helpers/cn";

type DetailItemProps = { key: string; label: string; value: React.ReactNode };

type DetailItemComponentProps = {
  detail: DetailItemProps;
  // Hides the per-item label at the lg2 breakpoint, for use in lists that render a single shared
  // header row instead of repeating labels per item.
  hideLabelAtDesktop?: boolean;
};

export function DetailItem({ detail, hideLabelAtDesktop }: DetailItemComponentProps) {
  return (
    <div>
      <dt className={cn("body-md", hideLabelAtDesktop && "tw:lg2:hidden")}>
        <b>{detail.label}</b>
      </dt>

      <dd className={cn("body-md tw:m-0! tw:font-normal! tw:md:row-start-2")}>{detail.value}</dd>
    </div>
  );
}
